<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2020-06-28 18:55:17
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-06-28 19:05:59
 * @Description: 
--> 
<template>
  <div class="aptitude-test-index">
    <p id="target">要复制的内容</p>
    <button
      class="copy"
      id="copyBtn"
      data-clipboard-action="copy"
      data-clipboard-target="#target"
      @click="copyPolicyNo"
    >复制</button>

    <img src="https://assets.rurushishi.com/web6006/wx01f0b018d4951434/1580734123000-72.jpg" alt />
  </div>
</template>

<script>
import Clipboard from "clipboard";
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    copyPolicyNo() {
      var clipboard = new Clipboard("#copyBtn");
      clipboard.on("success", function(e) {
        alert("复制成功", 1500);
        e.clearSelection();
      });
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="css" scoped>
.copy{
  width: 200px;
  height: 100px;
}
img {
  width: 100%;
}
</style>